export const getPoliza = (state) => {
   return state.poliza;
};
export const getPolizas = (state) => {
   return state.polizas;
};
